/**
 * 重置 axios
 * @author LiQingSong
 */
import store from '@/store'
import axios from 'axios'
import Qs from 'qs'
import { Message } from 'element-ui'
import {
  ajaxHeadersTokenKey,
  siteLoginRouter,
  ajaxResponseNoVerifyUrl
} from '@/settings'

// 创建一个axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_APIHOST, // url = api url + request url
  withCredentials: true, // 当跨域请求时发送cookie
  timeout: 0, // 请求超时时间,5000(单位毫秒) / 0 不做限制
  paramsSerializer: function(params) {
    return Qs.stringify(params, { arrayFormat: 'comma' })
  }
})

// 全局设置 - post请求头
// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器 - 在发送请求之前
service.interceptors.request.use(
  config => {
    // 如果设置了cType 说明是自定义 添加 Content-Type类型 为自定义post 做铺垫
    if (config.cType) {
      config.headers['Content-Type'] =
        'application/x-www-form-urlencoded;charset=UTF-8'
    }

    // 请根据实际情况修改
    if (store.getters.token) {
      // store.getters.token 加载时已在 [store/user] 用 getToken()获取Token
      // 让每个请求携带令牌
      // ajaxHeadersTokenKey -> ['X-Token'] 是自定义头key
      config.headers[ajaxHeadersTokenKey] = `Bearer ${store.getters.token}`
    }
    return config
  },
  error => {
    // 处理请求错误
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  /**
   * 通过自定义代码确定请求状态
   * 这只是一个例子
   * 您还可以通过HTTP状态码来判断状态
   */
  response => {
    const res = response.data
    const { status: code } = res

    // 如果自定义代码不是200，则判断为错误。
    if (Math.ceil(code / 10) !== 20) {
      // 获取替换后的字符串
      const reqUrl = response.config.url
        .split('?')[0]
        .replace(response.config.baseURL, '')
      const noVerifyBool = ajaxResponseNoVerifyUrl.includes(reqUrl)

      if (code === 401 && !noVerifyBool) {
        if (!noVerifyBool) {
          window.location.href = `/#${siteLoginRouter}`
        }
      } else {
        if (!noVerifyBool) {
          Message({
            message: res.msg || 'Error',
            type: 'error',
            duration: 5 * 1000
          })
        }
      }

      // 返回错误 走 catch
      return Promise.reject(res)
      // return Promise.reject(new Error(res.msg || 'Error'));
      // return res;
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    //console.log('err' + error.response.headers); // for debug
    //console.log('err' + error.response.data); // for debug
    //console.log('err' + error.response.status); // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

/**
 * 原 Axios 返回
 *
 * Method: get
 *     Request Headers
 *         无 - Content-Type
 *     Query String Parameters
 *         name: name
 *         age: age
 *
 * Method: post
 *     Request Headers
 *         Content-Type:application/json;charset=UTF-8
 *     Request Payload
 *         { name: name, age: age }
 *         Custom parameters
 *             { cType: true }  Mandatory Settings Content-Type:application/json;charset=UTF-8
 * ......
 */
export default service
